<template>
  <div class="row">
    <div class="col-12">
      <div class="new-button-div">
        <n-button @click.native="openItemAdd()" type="primary" round>
          <i slot="label" class="now-ui-icons ui-1_simple-add"></i>
          {{ $t("app.modules.category_product.add.title") }}
        </n-button>
      </div>
      <card card-body-classes="table-full-width" no-footer-line>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ $t("app.modules.category_product.title") }}
            </h4>
            <fg-input>
              <el-input
                type="search"
                class="mb-3"
                clearable
                prefix-icon="el-icon-search "
                style="width: 300px"
                :placeholder="$t('app.general.search')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>
          <el-table stripe :data="queriedData">
            <el-table-column
              prop="idCategoriaProducto"
              :label="
                this.$t('app.modules.category_product.headers.identifier')
              "
              sortable
              :min-width="280"
            >
            </el-table-column>
            <el-table-column
              prop="nombreCategoria"
              :label="this.$t('app.modules.category_product.headers.category')"
              sortable
              :min-width="200"
            >
            </el-table-column>
            <el-table-column
              className="is-center"
              labelClassName="is-center"
              :label="$t('app.modules.messages.headers.state')"
              :min-width="280"
            >
              <template slot-scope="props">
                <n-switch
                  v-model="props.row.activo"
                  @input="active(props.row)"
                  color="black"
                >
                  <i class="now-ui-icons ui-1_check" slot="on"></i>
                  <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                </n-switch>
              </template>
            </el-table-column>
            <el-table-column
              className="is-center"
              labelClassName="is-center"
              :width="100"
              fixed="right"
            >
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          EditItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.category_product.edit.title") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>
      <categoriaproducto-add />
      <categoriaproducto-edit />
    </div>
  </div>
</template>
<script>
import { Pagination as NPagination } from "src/components";
import Fuse from "fuse.js";
import { getResponse } from "@/util/utilities";

export default {
  components: {
    NPagination,
    CategoriaproductoAdd: () => import("./categoriaproductoAdd"),
    CategoriaproductoEdit: () => import("./categoriaproductoEdit")
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["nombreCategoria"],
      tableData: [],
      searchedData: []
    };
  },
  methods: {
    async init() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      }).then(null);

      let payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0,
        withCategories: true
      };

      let request = await this.$http.post(route("CategoriaProducto/getCategoria"), payload);
      let response = getResponse(request, null);

      if(response != null){
        this.tableData = response.categoriaProducto;
      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
      this.$swal.close();
    },
    async active(row) {

      let request = await this.$http.put(route("CategoriaProducto/UpdateStatusCategoriaProducto"), row);
      let response = getResponse(request, null);

      if(response != null){
        this.notifyMessage("success", this.$t("app.promps.save_success"));
        EventBus.$emit("reload-items");
      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
    },
    openItemAdd() {
      EventBus.$emit("categoriaproducto-add");
    },
    EditItem(index, row, ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("categoriaproducto-edit", row);
    },
    handleDelete(index, row) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteRow(row);
            Swal.fire({
              title: "Deleted!",
              text: `You deleted ${row.name}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          }
        });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    async searchAgain() {
      const options = {
        keys: this.propsToSearch,
        threshold: 0.1,
        shouldSort: false,
        caseSensitive:false
      };
      let fuseSearch = new Fuse(this.tableData, options);
      let result = this.tableData;
      if (this.searchQuery !== "") {
        result = fuseSearch
          .search(this.searchQuery)
          .map(result => result.item);
      }
      this.searchedData = result;
    },
  },
  mounted() {
    this.init();

    EventBus.$on("reload-items", () => {
      this.init();
    });
  },
  watch: {
    searchQuery() {
      this.searchAgain();
    }
  }
};
</script>
<style>
.form-group .el-input__inner {
  padding: 10px 18px 10px 30px !important;
}

.has-success.has-label:after, .has-danger.has-label:after {
  top: 42px;
}
</style>
